<template>
  <div class="companyAnalytics-page pa-6">
    <p-progress-linear v-if="isLoading && page.dataSource.isLoading" :indeterminate="true" color="base" height="10">
    </p-progress-linear>
    <p-container v-if="!isLoading && !page.dataSource.isLoading">
      <!-- Title -->
      <h2 class="mb-4">
        <p-button tertiary @click="$router.back()">
          <p-icon>keyboard_backspace</p-icon>
        </p-button>
        {{ page.pageTitle }}
      </h2>
      <p-row>
        <!-- Event Filter -->
        <p-col xs12 md6 lg3>
          <p-select
            v-if="isEventFilterVisible"
            v-model="page.eventsDataSource.filter.eventIdentifier"
            :label="$t('page.events.select.eventName')"
            :items="page.eventItems"
            @input="refreshAnalytics()"
          ></p-select>
        </p-col>
      </p-row>
      <p-list-view
        v-model="page.companiesAnalyticsList"
        :columns="page.companyColumns"
        :pagination.sync="page.companyAnalytics.paging"
        :loading="page.dataSource.isLoading"
      >
        <template slot="table-actions">
          <!-- Refresh Button -->
          <p-button :disabled="isLoading" @click="refreshAnalytics()">
            <p-icon>refresh</p-icon>
          </p-button>
        </template>
      </p-list-view>
    </p-container>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import { IDataSourcePaging } from '@glittr/frontend-core/src/core/v2/data/data-source';
  import CompanyAnalyticsPage from './analytics.vue.model';

  export default Vue.extend({
    name: 'CompanyAnalytics',
    auth: true,
    data: () => ({
      page: new CompanyAnalyticsPage(),
      isLoading: false,
      innerPagination: {} as IDataSourcePaging,
    }),
    computed: {
      isAdmin(): boolean {
        let isAdmin = false;
        if (this.$auth.isLoggedIn) {
          isAdmin = this.$auth.isInRole('Admin', 'HostAdmin');
        }
        return isAdmin;
      },
      isEventFilterVisible() {
        return this.$route.name !== 'myMembersCompanyAnalytics';
      },
    },
    watch: {
      'page.dataSource.paging': {
        handler() {
          this.innerPagination = this.page.dataSource.paging;
        },
      },
    },
    async beforeMount() {
      this.isLoading = true;
      await this.page.eventsDataSource.select();
      await this.page.loadEventLookup();
      await this.redirectToPage();
      await this.page.initialize();
      this.isLoading = false;
    },
    methods: {
      onPaginationChange() {
        this.$debounce(() => {
          this.page.dataSource.paging = this.innerPagination;
        }, 500, this)();
      },
      async refreshAnalytics() {
        try {
          await this.redirectToPage();
        } catch (error) {
          Vue.$log.error(`Error refreshing companies: ${error}`);
        }
      },
      async redirectToPage() {
        const companyId = Number.parseInt(this.$route.params.id, 10);
        if (this.$route.name === 'myMembersCompanyAnalytics') {
          this.page.useDataSourceById = true;
          this.page.companyAnalyticsById.filter.companyId = companyId;
          this.page.companyAnalyticsById.filter.eventIdentifier = this.page.eventsDataSource.filter.eventIdentifier;
          this.page.companyById.filter.id = companyId;
          this.page.companyById.filter.eventIdentifier = this.page.eventsDataSource.filter.eventIdentifier;
          await this.page.companyById.select();
          await this.page.companyAnalyticsById.select();
        } else if (this.$route.name === 'myCompanyAnalytics') {
          this.page.companyAnalytics.filter.eventIdentifier = this.page.eventsDataSource.filter.eventIdentifier;
          await this.page.companyAnalytics.select();
        } else if (this.$route.name === 'allMembersCompanyAnalytics') {
          this.page.useDataSourceById = true;
          this.page.companyById.filter.id = companyId;
          this.page.companyById.filter.eventIdentifier = this.page.eventsDataSource.filter.eventIdentifier;
          await this.page.companyById.select();
          this.page.companyAnalyticsById.filter.companyId = companyId;
          this.page.companyAnalyticsById.filter.eventIdentifier = this.page.eventsDataSource.filter.eventIdentifier;
          await this.page.companyAnalyticsById.select();
        }
      },
    },
  });
</script>
